const getUserAgent = (req) => {
  if (req) {
    return req.headers['user-agent'];
  } else if (typeof window !== 'undefined' && window.navigator) {
    return window.navigator.userAgent;
  }

  return '';
};

export default getUserAgent;
